import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/modules/material.module';

import { ChangeEnhancementVariantActionComponent } from './change-enhancement-variant-action/change-enhancement-variant-action.component';

const COMPONENTS = [ChangeEnhancementVariantActionComponent];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, MaterialModule],
  exports: COMPONENTS,
})
export class EnhancementVariantActionsModule {}
